<template>
  <v-dialog v-model="visible" max-width="638" persistent>
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          @click.native="close"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <form class="form--custom" novalidate @submit.prevent="handleSubmit">
        <v-card-text class="px-4 pt-0 pb-3">
          <p>{{ $t(`${namespace}.text`) }}</p>

          <label>{{ $t(`${namespace}.reasonLabel`) }}</label>
          <v-text-field
            v-model="reason"
            :placeholder="$t(`${namespace}.reasonPlaceholder`)"
            flat
            outline
            solo
            color="accent"
            :name="$t(`${namespace}.reasonName`)"
            v-validate="{ required: true, }"
            :error-messages="errors.collect($t(`${namespace}.reasonName`))"
            :data-vv-name="$t(`${namespace}.reasonName`)"
            required
            autocomplete="off"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer/>

          <a
            href="#"
            class="text--normal accent--text mr-4"
            color="accent"
            flat
            round
            @click.prevent="close"
          >
            {{ $t('Common.cancel') }}
          </a>

          <v-btn
            color="accent"
            depressed
            round
            @click.native="handleSubmit"
          >
            {{ $t('Common.proceed') }}
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReasonDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Views.InvoiceExtendDueDate.reasonDialog',
      reason: null
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },

    resetFields () {
      this.reason = null
    },

    async handleSubmit () {
      try {
        const isValid = await this.$validator.validateAll()

        if (isValid) {
          this.$emit('submit', this.reason)
          this.close()
        }
      } catch (err) {
        console.log('ERROR', err)
      }
    }
  },
  watch: {
    visible () {
      this.resetFields()
    }
  }
}
</script>
